<template>
  <b-container fluid
    ><b-row>
      <b-col class="top_bar" :style="{ background: course.color }" />
    </b-row>
    <b-row class="mb-3">
      <course-header :course="course" />
    </b-row>
    <b-row class="page_indentation mb-4">
      <next-session-bar :course="course" />
    </b-row>
    <b-row class="page_indentation mb-4">
      <session-report :course-id="course._id" :session="mostRecentSession" />
    </b-row>
    <b-row class="page_indentation">
      <b-col
        class="col-xl-auto col-sm-12 mr-5"
        v-if="courseObject.practiceExams.length"
      >
        <exam-score :course-id="course._id" />
      </b-col>
      <b-col class="col-xl-auto col-sm-12">
        <course-resources
          v-if="courseObject.resources && courseObject.resources.length"
          :resources="courseObject.resources"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";
import CourseHeader from "../../components/Course/CourseHeader";
import SessionReport from "../../components/SessionReports/SessionReport";
import CourseResources from "../../components/Course/CourseResources";
import NextSessionBar from "../../components/Course/NextSessionBar";
import ExamScore from "../../components/Course/ExamScore";

export default {
  name: "Course",
  components: {
    ExamScore,
    NextSessionBar,
    CourseResources,
    SessionReport,
    CourseHeader
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      courseGetter: StoreConstants.GETTERS.COURSE
    }),
    course: function() {
      return this.courseGetter(this.id);
    },
    courseObject: function() {
      return this.course.course;
    },
    mostRecentSession: function() {
      return this.course.sessionReports.length
        ? this.course.sessionReports[0]
        : {
            report:
              "This course hasn't met for any sessions yet. Once it has, you'll find a summary of the material covered here",
            assignment:
              "This is where you'll find your assignment, which should be completed before your next session"
          };
    }
  }
};
</script>

<style scoped></style>
